import { CommonModule } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
    selector: 'confirm-program-publish-action-dialog',
    template: `
<div class="dashboard_dialog joi-dialog">
  <div mat-dialog-content>
    <div class="dialog_content">
      <h3 [ngClass]="{warn_text:!data.publish}" >{{ data.publish ? ( data.currently_published ? 'Update' : 'Publish') : 'Unpublish' }} {{ data.isEventList ? 'Event List' : 'Page'}}</h3>
      <div class="para" *ngIf="data.publish && !data.currently_published">{{ data.isEventList ? ELPublishText : publishText }}</div>
      <div class="para" *ngIf="data.publish && data.currently_published">{{ data.isEventList ? ELUpdateText : updateText }}</div>
      <div class="para" *ngIf="!data.publish">{{ data.isEventList ? ELDeleteText : deleteText }}</div>
      <div class="para" *ngIf="!data.publish">You can republish to the same webpage at any time.</div>
      <div class="para" *ngIf="data.publish && data.isEventList"><b>Reminder:</b> Your event list will update automatically if an event’s published page is updated.</div>
    </div>
  </div>
  <div mat-dialog-actions>
    <button matButton (click)="dialogRef.close()">Cancel</button>
    <button matButton [color]="!data.publish ? 'warn' : 'primary'" (click)="confirm()">{{confirmButtonText}}</button>
  </div>
</div>
  `,
    styles: [`
      .dashboard_dialog .para { margin-bottom: 15px; }
      .dashboard_dialog h3 { padding-bottom: 20px; }
      `],
    standalone: true,
    imports: [MatButtonModule, CommonModule],
})
export class ConfirmProgramPublishActionDialogComponent {

  publishText = 'Your page will be published and a webpage will be generated so you can share the event with your audience.'
  ELPublishText = 'Your event list will be published and a webpage will be generated.'
  updateText = 'Your published page will be updated immediately.'
  ELUpdateText = 'Your event list will be updated immediately with new configuration settings.'
  deleteText = 'Your page will be unpublished immediately. Visitors to your shared webpage will not be able to see your event.'
  ELDeleteText = 'Your event list will be unpublished immediately. Visitors to your shared webpage will not be able to see your event list.'

  confirmButtonText: string;

  constructor(public dialogRef: MatDialogRef<ConfirmProgramPublishActionDialogComponent>, @Inject(MAT_DIALOG_DATA) public data: ConfirmPublishActionDialogData) {
    this.confirmButtonText = data.publish
      ? (data.currently_published ? 'Update now' : 'Publish now')
      : 'Unpublish now';
  }

  confirm() {
    this.dialogRef.close(true)
  }
}

export interface ConfirmPublishActionDialogData {
  publish: boolean
  currently_published: boolean
  isEventList?: boolean
}